export default "__VITE_ASSET__B6brR0MK__"